import {Component, ElementRef, HostListener, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { fadeHeightAnimation } from '../../../../pages/nouveau/nouveau-animation';
import { MatSnackBar, MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Tiers } from '../../../../../Interfaces/Tiers';
import { TiersService,DialogService } from '../../../../../services';

import {
    FormDialogFormulaireWithSFComponent
} from "../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component";


@Component({
    selector: 'atyl-recherche-tiers-dialog',
    templateUrl: './recherche-tiers-dialog.component.html',
    styleUrls: ['./recherche-tiers-dialog.component.scss'],
    animations: [fadeHeightAnimation],
})
export class RechercheTiersDialogComponent implements OnInit {
    @Input() form: any;
    appelApi = new Subject();
    loading = false;
    selected: Tiers[];
    strRecherche: string;
    tiersList: any[];
    titreColonnes: string[];
    titreColonnesObj: any;
    typeTiers: 'ENFANT' | 'USAGER' | 'FOYER';
    noResult: boolean;
	formid:any;
    /**
     * La barre de recherche.
     * Cette variable est utilisée pour donner le focus à la barre de recherche
     * lorsqu'on appuie sur une touche de clavier.
     */
    @ViewChild('barreDeRecherche', {
        static: false,
    }) barreDeRecherche: ElementRef;

    /**
     * En appuyant sur les touches de clavier, focus directement la barre de recherche
     *
     * @param event l'événement d'appui sur une touche de clavier
     */
    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.ctrlKey || event.altKey) {
            return;
        }

        // if (this.barreDeRecherche.nativeElement != document.activeElement) {
        //     this.barreDeRecherche.nativeElement.focus();
        // }
    }

    constructor(
        private tierService: TiersService,
        private dialogService: DialogService,
        private dialogRef: MatDialogRef<RechercheTiersDialogComponent>,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        this.strRecherche = "";
        this.tiersList = [];
        this.selected = [];
        
        if (this.data && Object.keys(this.data).length != 0) {
            if (this.data.selected) {
                this.selected = this.data.selected.slice();
            }
            this.typeTiers = this.data.typeTier;
            this.tiersList = this.selected.slice();
            this.titreColonnesObj = this.data.titreColonnes;

            let arr = []
            for (let titreObj of this.titreColonnesObj) {
                arr.push(titreObj.columnRef);
            }
            this.titreColonnes = arr;
            if (this.data.formid!=undefined)
              	this.formid=this.data.formid;
        }
       console.log("RechercheTiersDialogComponent ngOnInit",this.data,this.formid)
        // service de recherche
        this.appelApi.pipe(
            switchMap(_ => this.tierService.search(this.typeTiers, {
                search: '*' + this.strRecherche + '*'
            }))
        ).subscribe((res) => {
            if (res.result != undefined && res.result) {
                this.tiersList = res.result.datas;
                this.tiersList = this.filterBySelected();
                this.tiersList = this.tiersList.slice(0, 25);
                this.tiersList = this.selected.concat(this.tiersList);
                this.noResult = res.result.datas.length == 0;
            } else {
                this.errorFunction();
            }
            this.loading = false;
        }, (_e) => this.errorFunction());
    }

    ngOnDestroy() {
        this.appelApi.unsubscribe();
    }

    /**
     * Format une date en dd/mm/yyyy
     *
     * @param date date en string à formatter
     * @returns la date formatée
     */
    formatDate(date: string): string {
        let dateObj = new Date(date);

        let year: string | number = dateObj.getFullYear();
        let month: string | number = dateObj.getMonth() + 1;
        let day: string | number = dateObj.getDate();

        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;

        return day + "/" + month + "/" + year;
    }

    /**
     * Supprime les éléments qui existent déjà dans la liste des tiers sélectionnés.
     *
     * @returns la liste des tiers sans ceux qui sont sélectionnés
     */
    filterBySelected(): Tiers[] {
        let arrayCopy = this.tiersList.slice();
        for (let i = this.selected.length - 1; i >= 0; i--) {
            let index = this.indexOfElementInList(this.selected[i], arrayCopy);
            if (index != -1) {
                arrayCopy.splice(index, 1);
            }
        }
        return arrayCopy;
    }

    /**
     * Trouve l'index d'un element donné dans une liste.
     * Renvoie -1 si l'élément n'est pas dans la liste.
     *
     * @param el l'élément qu'on cherche
     * @param array la liste dans laquelle on cherche
     * @returns l'index de l'élément trouve
     */
    indexOfElementInList(el: Tiers, array: Tiers[]): number {
        let index = -1;
        for (let i = 0; i < array.length; i++) {
            if (array[i].ID == el.ID) {
                index = i;
            }
        }
        return index;
    }

    /**
     * Vérifie si un élément est dans la liste des tiers sélectionnés.
     *
     * @param el l'élément qu'on veut verifier
     * @returns un boolean indiquant si l'élément est sélectionnés
     */
    isSelected(el: Tiers): boolean {
        return this.selected.includes(el);
    }

    /**
     * Ferme le dialog.
     * 0 ferme le dialog.
     * 1 ferme le dialog et renvoie la liste des tiers sélectionnés
     * 2 ferme le dialog et ouvre le dialog de creation de foyer
     *
     * @param mode mode de fermeture
     */
    closeDialog(mode: number): void {
        switch (mode) {
            case 0:
            case 2:
                this.dialogRef.close({mode});
                break;
            case 1:
                this.dialogRef.close({mode, selected: this.selected});
                break;
            default:
                this.dialogRef.close();
                break;
        }
    }

    /**
     * Cette fonction gère les événements du clavier,
     * - En appuyant sur entrer, on sélectionne le tier le plus haut dans la liste.
     * - En appuyant sur les autres touches, on écrit dans la barre de recherche et lance une recherche.
     *
     * @param ev KeyboardEvent
     */
    onKeyUp(ev: KeyboardEvent) {
        if (ev.key == 'Enter') {
            this.search();
        } else {
            const key = ev.key.toLowerCase();

            if (key.length == 1 || key == 'backspace') {
                const isLettre = (key >= 'a' && key <= 'z');
                const isNumber = (key >= '0' && key <= '9');
                const isBackspace = (key == 'backspace');

                if (isLettre || isNumber || isBackspace) {
                    this.search();
                }
            }
        }
    }

    /**
     * Ajoute à la liste des tiers sélectionnés
     * le premier tiers de listeTiers qui n'est pas dans selected.
     */
    select() {
        let i = 0;
        while (this.selected.includes(this.tiersList[i])) {
            i++;
            if (i >= this.tiersList.length) {
                break;
            }
        }
        if (i < this.tiersList.length) {
            this.selected.push(this.tiersList[i]);
        }
    }

    /**
     * Sélectionne un tiers s'il n'est pas sélectionné,
     * désélectionne s'il est déjà sélectionné.
     *
     * @param row la ligne de tiers dans la table
     */
    toggleSelect(row: Tiers) {
        if (!this.selected.includes(row)) {
            this.selected.push(row);
        } else {
            this.selected.splice(this.selected.indexOf(row), 1);
        }
    }

    /**
     * annule la dernière requête de recherche et lance une nouvelle.
     */
    search() {
        this.loading = true;
        this.appelApi.next();
    }

    /**
     * récupère une ou plusieurs colonnes d'un tiers par rapport
     * au type de titreObj donnée.
     *
     * @param titreObj l'objet depuis lequel on récupère le type.
     * @param tiers le tiers depuis lequel on récupère les données.
     * @returns la chaine générée
     */
    dataValue(titreObj: any, tiers: Tiers) {
        switch (titreObj.type) {
            case 'date':
                return this.formatDate(tiers[titreObj.columnKey]);
            case 'adresse-principale':
                let str = ""
                if (Array.isArray(titreObj.columnKey)) {
                    if (tiers.adresses.PRINCIPALE[titreObj.columnKey[0]]) {
                        str += tiers.adresses.PRINCIPALE[titreObj.columnKey[0]] + " ";
                    }
                    if (tiers.adresses.PRINCIPALE[titreObj.columnKey[1]]) {
                        str += tiers.adresses.PRINCIPALE[titreObj.columnKey[1]];
                    }
                } else {
                    str = tiers.adresses.PRINCIPALE[titreObj.columnKey] || '';
                }
                return str;
            default:
                return tiers[titreObj.columnKey] || '';
        }
    }

    /**
     * Affiche une erreur
     */
    errorFunction() {
        this.loading = false;
        this.snackBar.open('Une erreur est survenue', undefined, { duration: 5000 });
    }

    updateSelection() {
        this.tiersList = this.filterBySelected();
        this.tiersList = this.selected.concat(this.tiersList);
    }
    createNew() {
	
	    let idf:any=(this.typeTiers=='ENFANT') ?  this.formid.ENFANT: this.formid.USAGER
	    
	    console.log("createNew",this.formid,idf);
		this.dialogForm(idf);
		/*
		dialogForm(
                                'ENFANT'==form.tiers_type[0].type.code
                                    ? idFormOf.ENFANT
                                    : idFormOf.USAGER
                            )
	*/
	}
     /**
     * ouvre un dialog d'un formulaire
     *
     * @param idForm id de formulaire
     * @param tiers le tiers ayant un dossier pour pouvoir préremplir le formulaire
     * @param afterClosed la fonction après la fermeture de dialog
     */
    dialogForm(idForm: number, tiers?: Tiers, afterClosed?: Function) {
        let data = {
            idAForm: idForm,
            create: true,
            closeWhenValidate: true,
            v3: true,
        }
        if (tiers) {
            data['dossier'] = tiers['dossier'];
        }
        this.dialogService.open(FormDialogFormulaireWithSFComponent, {
            data: data,
            height: "90vh",
            width: "90vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, () => {
            if (afterClosed) {
                let fun = afterClosed.bind(this);
                fun(tiers);
            }
        })
    }
    
}
